import type { Reference, Resource } from '@medplum/fhirtypes'
import type { ExtendedResource } from '@seen/core/ExtendedResource'
import { generateMedplumAppLink } from '@seen/core/utilsExtendedResource'
import type { JSX } from 'react'
import { ExternalLink } from '#src/components/ExternalLink.tsx'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'
export function DevMedplumAppLinkOverlay(props: {
  to: Resource | Reference | ExtendedResource<any>
  pathSuffix?: string
  inline?: boolean
  size?: number
}): JSX.Element | null {
  const showLinkOverlay = usePortalStore((state) => state.showLinkOverlay)

  if (!showLinkOverlay) {
    return null
  }

  const url = generateMedplumAppLink(props.to, props.pathSuffix)
  return <ExternalLink href={url} />
}
